<template lang="pug">
AppMapMarker.activities-location-job-site-marker(
  :marker="marker"
  has-icon
  :z-index="zIndex"
  :icon-size="size"
  has-tooltip
  has-info-window
  :is-clickable="isClickable"
  :show-marker="showMarker"
  :show-marker-tooltip="showMarkerTooltip"
  :show-marker-radius="showRadius"
  :centered-on-coordinates="false"
  :show-info-window="showInfoWindow"
  :info-window-options="infoWindowOptions"
  :circle-options="markerCircleOptions"
  :icon-url="iconUrl"
  @click="$emit('click', $event)"
  @input="$emit('input', $event)"
  @info-window="$emit('info-window', $event)"
  @close-info="$emit('close-info', $event)"
)
  template(slot="infoWindow")
    ActivitiesLocationJobSiteInfoWindow(
      v-if="showInfoWindow"
      :marker="marker"
      @click="$emit('click-info-window', $event)"
      @close="$emit('close-info', $event)"
    )
  template(slot="tooltip")
    | {{ marker.name }}
</template>

<script>
import { mapGetters } from 'vuex';
import { activitiesMarker } from '~/mixins';
import generateCustomColorMarker from '../../utils/generate_custom_color_marker';

export default {
  name: 'ActivitiesLocationJobSiteMarker',
  mixins: [activitiesMarker({ zIndex: 3 })],
  props: {
    isClickable: {
      type: Boolean,
      default: true,
    },
    showMarker: {
      type: Boolean,
      default: true,
    },
    showMarkerTooltip: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters(['reportUrl']),
    infoWindowOptions: () => ({ pixelOffset: { width: 0, height: -70 } }),
    iconUrl() {
      return generateCustomColorMarker(this.marker.color);
    },
    markerCircleOptions() {
      const { color } = this.marker;

      return {
        fillColor: color,
        strokeColor: color,
        fillOpacity: 0.3,
      };
    },
  },
};
</script>
